import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "31",
  height: "31",
  viewBox: "0 0 31 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.625 24.4092L21.125 26.9092L26.75 21.2842M27.9814 16.3465C27.9938 16.119 28 15.8898 28 15.6592C28 8.75562 22.4036 3.15918 15.5 3.15918C8.59644 3.15918 3 8.75562 3 15.6592C3 22.4534 8.42064 27.9816 15.1731 28.155M15.5 8.15918V15.6592L20.173 17.9957",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }